import { record_type, string_type, class_type } from "./.fable/fable-library.3.1.11/Reflection.js";
import { Record } from "./.fable/fable-library.3.1.11/Types.js";
import { createElement } from "react";
import { Interop_reactApi } from "./.fable/Feliz.1.42.0/Interop.fs.js";
import cit$002Dlogo from "./cit-logo.png";
import { cons, singleton, ofArray } from "./.fable/fable-library.3.1.11/List.js";
import { createObj } from "./.fable/fable-library.3.1.11/Util.js";
import { Helpers_extractClasses, Helpers_combineClasses } from "./.fable/Feliz.Bulma.2.15.0/ElementBuilders.fs.js";
import { join, interpolate, toText } from "./.fable/fable-library.3.1.11/String.js";
import { map, delay, toList } from "./.fable/fable-library.3.1.11/Seq.js";
import { tippy, Placement, Placement__get_Value, Plugins_inlinePositioning, Plugins_animateFill, Plugins_followCursor, splitChildProps } from "./.fable/Feliz.Tippy.0.0.4/Feliz.Tippy.fs.js";

export class CitColors {
    constructor() {
    }
}

export function CitColors$reflection() {
    return class_type("App.CitColors", void 0, CitColors);
}

export function CitColors_get_lightBlue() {
    return "#40a8b7";
}

export function CitColors_get_green() {
    return "#8cbf41";
}

export function CitColors_get_yellow() {
    return "#fec903";
}

export function CitColors_get_red() {
    return "#e1053a";
}

export function CitColors_get_orange() {
    return "#e97305";
}

export function CitColors_get_darkBlue() {
    return "#102035";
}

export class Package extends Record {
    constructor(Name, Link) {
        super();
        this.Name = Name;
        this.Link = Link;
    }
}

export function Package$reflection() {
    return record_type("App.Package", [], Package, () => [["Name", string_type], ["Link", string_type]]);
}

export class StyledComponents {
    constructor() {
    }
}

export function StyledComponents$reflection() {
    return class_type("App.StyledComponents", void 0, StyledComponents);
}

export function StyledComponents_Container_6E3A73D(children) {
    return createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            padding: 50,
            maxWidth: 1000,
            margin: (0 + "px ") + "auto",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function StyledComponents_Row_6E3A73D(children) {
    return createElement("div", {
        style: {
            alignItems: "center",
            display: "flex",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function StyledComponents_NavbarLink(label, link) {
    return createElement("a", {
        style: {
            margin: ((((((20 + "px ") + 0) + "px ") + 20) + "px ") + 20) + "px",
            color: "white",
            fontSize: 20 + "px",
            fontWeight: "bold",
        },
        href: link,
        children: label,
    });
}

export function StyledComponents_Navbar() {
    let props_1;
    const logo = cit$002Dlogo;
    return createElement("div", {
        style: {
            padding: ((0 + "px ") + 20) + "px",
            backgroundColor: CitColors_get_darkBlue(),
            height: 70,
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        children: Interop_reactApi.Children.toArray([createElement("div", {
            style: {
                width: 1000,
                margin: (0 + "px ") + "auto",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: ((0 + "px ") + 40) + "px",
            },
            children: Interop_reactApi.Children.toArray([StyledComponents_Row_6E3A73D(ofArray([createElement("img", {
                style: {
                    height: 50,
                },
                src: logo,
            }), (props_1 = ofArray([["style", {
                color: "#FFFFFF",
                fontSize: 1.5 + "rem",
            }], ["children", "Compositional IT"]]), createElement("h1", createObj(Helpers_combineClasses("title", props_1))))]))]),
        })]),
    });
}

export function StyledComponents_SubHeading_Z721C83C5(label) {
    const props = ofArray([["style", {
        borderBottom: (((2 + "px ") + "solid") + " ") + CitColors_get_darkBlue(),
        marginTop: 30,
        paddingBottom: 10,
    }], ["children", label]]);
    return createElement("h2", createObj(Helpers_combineClasses("subtitle", props)));
}

export function StyledComponents_Link_Z2FD1DF10(p) {
    return createElement("a", {
        style: {
            color: CitColors_get_darkBlue(),
            fontWeight: "bold",
            borderBottom: (((2 + "px ") + "solid") + " ") + CitColors_get_darkBlue(),
        },
        children: p.Name,
        href: p.Link,
    });
}

export function StyledComponents_Description(wrapperName, wrappedComponent, nuget, npm) {
    let value, elms, children_4, children, children_2;
    const children_7 = ofArray([StyledComponents_SubHeading_Z721C83C5(wrapperName), (value = toText(interpolate("Feliz style bindings for %P()", [wrappedComponent])), createElement("b", {
        children: [value],
    })), (elms = singleton((children_4 = ofArray([(children = singleton(StyledComponents_Link_Z2FD1DF10(nuget)), createElement("li", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })), (children_2 = singleton(StyledComponents_Link_Z2FD1DF10(npm)), createElement("li", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    }))]), createElement("ul", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    }))), createElement("div", {
        className: "content",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    }))]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_7)),
    });
}

export function StyledComponents_HeadingWithContent(title, children) {
    const children_1 = ofArray([StyledComponents_SubHeading_Z721C83C5(title), children]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_1)),
    });
}

export function StyledComponents_Checkbox_58BC8925(updateProp) {
    const props = ofArray([["style", {
        height: 30,
        width: 30,
    }], ["onClick", updateProp]]);
    return createElement("input", createObj(cons(["type", "checkbox"], Helpers_combineClasses("checkbox", props))));
}

export function StyledComponents_LabelWithCircleButton(name, updater) {
    return createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
        },
        children: Interop_reactApi.Children.toArray([createElement("b", {
            children: [name],
        }), StyledComponents_Checkbox_58BC8925(updater)]),
    });
}

export function StyledComponents_CodeBlock_Z721C83C5(code) {
    return createElement("pre", {
        style: {
            padding: 20,
            fontSize: 15 + "px",
            backgroundColor: "#f5f5f5",
            borderRadius: 5,
        },
        children: code,
    });
}

export function StyledComponents_Select(items, handler) {
    const patternInput = Helpers_extractClasses(ofArray([["style", {
        width: 150,
        border: (((1 + "px ") + "solid") + " ") + "#767676",
    }], ["className", "center-select"], ["onChange", handler], ["children", Interop_reactApi.Children.toArray(Array.from(toList(delay(() => map((item) => createElement("option", {
        style: {
            color: CitColors_get_darkBlue(),
        },
        value: item,
        children: item,
    }), items)))))]]));
    return createElement("div", {
        className: join(" ", cons("select", patternInput[0])),
        children: Interop_reactApi.Children.toArray([createElement("select", createObj(patternInput[1]))]),
    });
}

export function StyledComponents_LabelWithSelect(name, items, handler) {
    return createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
        },
        children: Interop_reactApi.Children.toArray([createElement("b", {
            children: [name],
        }), StyledComponents_Select(items, handler)]),
    });
}

export function StyledComponents_Footer_6E3A73D(children) {
    return createElement("div", {
        style: {
            backgroundColor: "#102035",
            height: 300,
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export class Components {
    constructor() {
    }
}

export function Components$reflection() {
    return class_type("App.Components", void 0, Components);
}

export function Components_Demo() {
    let children, elements;
    return StyledComponents_Container_6E3A73D(singleton(createElement("div", {
        style: {
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "column",
        },
        children: Interop_reactApi.Children.toArray([(children = ofArray([StyledComponents_Description("Feliz.Tippy", "tippyjs/react", new Package("nuget", "https://www.nuget.org/packages/Feliz.Tippy/"), new Package("npm", "https://www.npmjs.com/package/@tippyjs/react")), StyledComponents_HeadingWithContent("Demo", createElement("div", {
            style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            },
            children: Interop_reactApi.Children.toArray([(elements = splitChildProps([["plugins", [Plugins_followCursor, Plugins_animateFill, Plugins_inlinePositioning]], ["content", createElement("p", {
                children: ["hello from tippy :)"],
            })], ["children", Interop_reactApi.Children.toArray([createElement("a", createObj(Helpers_combineClasses("button", singleton(["children", "HOVER OVER ME"]))))])], ["placement", Placement__get_Value(new Placement(12))], ["animateFill", true], ["interactive", true]]), Interop_reactApi.createElement(tippy, createObj(elements.Props), ...elements.Children))]),
        })), StyledComponents_HeadingWithContent("Installation", StyledComponents_CodeBlock_Z721C83C5("\r\ncd ./project\r\nfemto install Feliz.Tippy")), StyledComponents_HeadingWithContent("Sample Code", StyledComponents_CodeBlock_Z721C83C5("\r\nopen Feliz.Tippy\r\n\r\nTippy.create [\r\n    Tippy.plugins [|\r\n        Plugins.followCursor\r\n        Plugins.animateFill\r\n        Plugins.inlinePositioning |]\r\n    Tippy.content ( Html.p \"hello from tippy :)\" )\r\n    prop.children [\r\n        Bulma.button.a [\r\n            prop.text \"HOVER OVER ME\"\r\n        ]\r\n    ]\r\n    Tippy.placement Auto\r\n    Tippy.animateFill\r\n    Tippy.interactive\r\n]"))]), createElement("div", {
            children: Interop_reactApi.Children.toArray(Array.from(children)),
        }))]),
    })));
}

export function Components_Documentation() {
    const children = ofArray([StyledComponents_Navbar(), createElement(Components_Demo, null)]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

